import type { ActiveElement, ChartEvent } from "chart.js";

const legendOption = {
  labels: {
    boxWidth: 8,
    boxHeight: 8,
    borderRadius: 4,
    useBorderRadius: true,
  },
};

const onHoverCursorOption = (
  event: ChartEvent,
  chartElement: ActiveElement[],
) => {
  if (!event?.native?.target) {
    return null;
  }

  if (chartElement.length === 1) {
    (event.native.target as HTMLElement).style.cursor = "pointer";
  }

  if (chartElement.length === 0) {
    (event.native.target as HTMLElement).style.cursor = "default";
  }

  return null;
};

export const commonChartOptions = { legendOption, onHoverCursorOption };
